import PropTypes from 'prop-types';
import React from 'react';
import {TooltipArrow, TooltipContent, TooltipContentSlim,TooltipArrowSlim} from '../StyleTooltip';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const Content = ({ children, ...otherProps }) => {
    return (
        <TooltipContentSlim
            {...otherProps}
        >
            <TooltipArrowSlim />
            {children}
        </TooltipContentSlim>

    );
}

Content.propTypes = propTypes;
Content.displayName = 'Content';

export default Content;
